import { useOrganization } from "@/context/providers/OrganizationProvider";
import { SUPERADMIN_ROLE_ID } from '@/constants/allconstants';
import { getCurrentOrganization } from "../functions/OrganizationFunctions";

/** Superadmin for the currently selected organization; updates on org switch. */
export function isSuperAdmin(organization: { roles?: string[] } | null = getCurrentOrganization()) {
    return Boolean(organization?.roles?.includes(SUPERADMIN_ROLE_ID));
}

export function useIsSuperAdmin(): boolean {
    const { organization } = useOrganization();
    return isSuperAdmin(organization);
}
